import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { SaleOrderLine } from '../sale-order-line';
import { SaleOrderLineProductBuilder } from './sale-order-line-product-builder';
import { SaleOrderLineComplementBuilder } from './sale-order-line-complement-builder';
import { SaleOrderLineOtherBuilder } from './sale-order-line-other-builder';
import { parseNumber } from '../../utils/number.utils';

export class SaleOrderLineBuilder {

  static fromJson(json): SaleOrderLine {
    return (json) ? new SaleOrderLine(
      json.hash,
      parseNumber(json.type),
      parseNumber(json.position),
      SaleOrderLineProductBuilder.fromJson(json.saleOrderLineProduct),
      SaleOrderLineComplementBuilder.fromJson(json.saleOrderLineComplement),
      SaleOrderLineOtherBuilder.fromJson(json.saleOrderLineOther),
    ) : null;
  }

  static fromJsonList(list): SaleOrderLine[] {
    return (isArray(list)) ? sortByNumber('position', mapCollection(SaleOrderLineBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-line-builder.ts